<template>
    <tr @click="recordSelected" class="my-4">
        <td style="padding: 0 6px">{{ index + 1 }}</td>

        <td style="padding: 0 16px" v-if="lessonSelected.formLevel >= 4">{{ markRecord.class_id }}</td>
        
        <td  style="padding: 0px 6px">
            <span>
                {{ markRecord.name }}
            </span>
        </td> 

        <td  style="padding: 0 6px">
            <v-text-field
                v-model="weightedCourseMark"
                outlined
                dense
                filled
                disabled
                hide-details
                type="number"      
            >                
            </v-text-field>
        </td>

        <td  style="padding: 0 6px">
            <v-text-field
                v-model="markRecord.exam_mark"
                outlined
                dense
                hide-details
                type="number"
                min=0
                :max="examMax"
                oninput="if(Number(this.value) > this.max) this.value = this.max; else if(Number(this.value) < this.min) this.value = this.min" 
                @blur="recordChanged"
                :filled="disableExamMark"
                :disabled="disableExamMark"
            ></v-text-field>
        </td>
        
        <td  style="padding: 0 6px">
           <v-select
                v-model="markRecord.app1"                
                :items="grades"
                item-value="grade"
                outlined
                dense
                hide-details
                @change="recordChanged"
            >
                <template v-slot:selection="{ item }">
                    <v-chip
                        small
                        close
                        @click:close="markRecord.app1 = null" 
                    >
                        {{ item.grade }}
                    </v-chip>
                </template>

                <template
                    v-slot:item=data
                > 
                    {{ data.item.grade }} {{ data.item.description }}
                </template> 

            </v-select>
        </td>

         <td  style="padding: 0 6px">
           <v-select
                v-model="markRecord.con1"                
                :items="grades"
                item-value="grade"
                outlined
                dense
                hide-details
                @change="recordChanged"                
            >
                <template v-slot:selection="{ item }">
                    <v-chip
                        small
                        close
                        @click:close="markRecord.con1 = null" 
                    >
                        {{ item.grade }}
                    </v-chip>
                </template>

                <template
                    v-slot:item=data
                > 
                    {{ data.item.grade }} {{ data.item.description }}
                </template> 

            </v-select>
        </td>
        
        <td  style="padding: 0 6px">
           <v-select
                v-model="markRecord.coded_comment"                
                :items="codedComments1"
                item-value="id"
                outlined
                dense
                hide-details
                @change="recordChanged"                
            >
                <template v-slot:selection="{ item }">
                    <v-chip
                        small
                        close
                        @click:close="markRecord.coded_comment = null" 
                    >
                        {{ item.id }}
                    </v-chip>
                </template>    

                <template
                    v-slot:item=data
                > 
                    {{ data.item.id}} {{ data.item.detail }}
                </template> 

            </v-select>
        </td>

        <td style="padding: 0 6px"> 
            <v-select
                v-model="markRecord.coded_comment_1"                
                :items="codedComments2"
                item-value="id"
                outlined
                dense
                hide-details
                @change="recordChanged"                
            >
                <template v-slot:selection="{ item }">
                    <v-chip
                        small
                        close
                        @click:close="markRecord.coded_comment_1 = null" 
                    >
                        {{ item.id }}
                    </v-chip>
                </template> 

                <template
                    v-slot:item=data
                > 
                    {{ data.item.id}} {{ data.item.detail }}
                </template>
            </v-select>
        </td>


        

        <td style="padding: 0 6px">
            <v-tooltip 
                bottom
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        small
                        color="green"                        
                        v-bind="attrs"
                        v-on="on"
                        v-show="saveStatus.saved"
                        class="mr-2"
                    >
                        mdi-check-all
                    </v-icon>
                </template>    
                <span>Saved</span>                
            </v-tooltip>

            <v-tooltip 
                top
            >
                <template v-slot:activator="{ on, attrs }">
                    <v-icon
                        small
                        color="red"                       
                        v-bind="attrs"
                        v-on="on"
                        v-show="saveStatus.error"
                    >
                        mdi-alert-circle
                    </v-icon>
                </template>    
                <span>Error</span>               
            </v-tooltip>

            <v-progress-circular
                indeterminate
                color="primary"
                v-show="saveStatus.saving"
                size="16"
                width="3"
            ></v-progress-circular>
        </td>
    </tr>

    
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
export default {
    props:{
        studentRecord: Object,
        formLevel: Number, 
        index: Number, 
        weightedExam: Boolean,
        examMax: Number,
        courseMax: Number,      
    },
    created () {
        this.initialize();
    }, 

    watch: {        
        studentRecord: {
            deep: true,
            handler (val){
                this.markRecord = {...val};
                
            }
        },

        
    }, 

    data() {
        return {
            markRecord: {},
            disableExamMark: false,
            disableCourseMark: true,
            termTwo: false,
            grades: [
                { grade: '10', description: 'Excellent'},
                { grade: '9', description: 'Very Good'},
                { grade: '8', description: 'Good'},
                { grade: '7', description: 'Fair'},
                { grade: '6', description: 'Poor'},
                { grade: '5', description: 'Unsatisfactory'},
            ],
            saveStatus: {
                saved: false,
                saving: false,
                error: false
            },
            codedComments1: [],
            codedComments2: [],
        }
    },
    computed: {
        ...mapGetters({
            employeeId: 'auth/getEmployeeId',
            marksEntered: 'termReports/getSubjectStudentsMarksEntered',
            lessonSelected: 'termReports/getLessonSelected',
            table2Records: 'termReports/getTable2Records',
            currentTerm: 'termReports/getCurrentTerm',
            commentSheet: 'termReports/getCommentSheetEnterMarks', 
            codedComments: 'termReports/getCodedComments',
        }),
       
        weightedCourseMark () {
            // const { formLevel } = this.lessonSelected;

            // const { term } = this.markRecord;

            const course_mark = this.markRecord.course_mark ?? 0;

            // if( term == 1 && formLevel >= 5 ) return course_mark.toFixed(1);

            // if( term == 2 && formLevel <= 4) return course_mark.toFixed(1);

            // if( term == 2 && formLevel >=5) return null;

            return  course_mark.toFixed(1);
        }
       
    },
    methods : {
        ...mapMutations({
            setUpdatedRecord: 'termReports/setUpdatedTable2Record',
            setStudentSelected: 'termReports/setMarkSheetStudentSelected',
            setMarkSheetEntered: 'termReports/setSubjectStudentsMarksEntered',
            setCommentSheet: 'termReports/setCommentSheetEnterMarks',
            setSelectedTable2RecordIndex: 'termReports/setSelectedTable2RecordIndex',
        }),

        ...mapActions({
            save: 'termReports/saveTable2Record',
            getStudents: 'termReports/getStudents', 
        }),
        
        initialize(){
            this.markRecord = {...this.studentRecord};
            this.codedComments1 = [...this.codedComments];
            this.codedComments2 = [...this.codedComments];
            this.setStudentSelected(null);
            this.savedDataCheck();
            this.setDisabledFields();
                       
        },

        async recordChanged(){
            console.log('saving record...')
            if(this.recordBlankCheck()) return;

            this.setSaveStatus();

            this.setUpdatedRecord(
                {
                    "student_id" : this.markRecord.student_id,
                    "year" : this.markRecord.year,
                    "term" : this.markRecord.term,
                    "subject_id" : this.markRecord.subject_id,
                    "exam_mark" : this.markRecord.exam_mark,
                    "course_mark" : this.markRecord.course_mark,
                    "app1" : this.markRecord.app1,
                    "con1" : this.markRecord.con1,                   
                    "coded_comment" : this.markRecord.coded_comment,
                    "coded_comment_1" : this.markRecord.coded_comment_1,
                    "employee_id" : this.employeeId,                   
                }
            );

                
            try {
                await this.save();
                await this.getStudents(this.id);
                this.setSaveStatus('saved');
            } catch (error) {
                error.response ? console.log(error.response) : console.log(error);
                this.$emit('error', error?.response ?? null);
                this.setSaveStatus('error');
            }

        },

        setSaveStatus (status = 'saving') {
           Object.keys(this.saveStatus).forEach(key => {
               this.saveStatus[key] = false;
               if(key == status) this.saveStatus[key] = true
           })
        },

        recordBlankCheck(){
            let record = [];
            let blank = true;                     
            // record.push(this.markRecord.course_mark);
            record.push(this.markRecord.exam_mark); 
            record.push(this.markRecord.comment);
            record.push(this.markRecord.app1);
            record.push(this.markRecord.con1);
            record.push(this.markRecord.coded_comment);
            record.push(this.markRecord.coded_comment_1);
                       
            record.forEach(element => {
                if(element) blank = false;
            })
            return blank;
        },
        savedDataCheck(){
            if(!this.recordBlankCheck()) this.saved = true;
        },
        recordSelected(){
            let records = this.table2Records;
            let entered = 0;
            records.forEach(record => {
                if(record.course_mark || record.exam_mark ){
                    entered++;
                }
            })
            console.log('entered:', entered);
            this.setStudentSelected(this.markRecord.name);
        },        
       
        setDisabledFields(){           
            // console.log(`Setting disabled fields...`)
            if(this.currentTerm == 2 && this.formLevel <= 4){
                this.disableExamMark = true;            
            }
            
        },
        
        openBottomSheet () {
            // this.setSelectedTable2RecordIndex(this.table2Records.indexOf(this.studentRecord));
            const index = this.table2Records.findIndex((record) => record.student_id == this.studentRecord.student_id);
            this.setSelectedTable2RecordIndex(index);
            this.$refs.commentTextarea?.$el?.querySelector('textarea')?.blur();
            this.setCommentSheet(true);
            
        }
    }
}
</script>

<style scoped> 
    ::v-deep .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded) > .v-input__control > .v-input__slot, .v-text-field.v-text-field--enclosed .v-text-field__details{
        padding: 0 6px;
    }

    /* Chrome, Safari, Edge, Opera */
    ::v-deep input::-webkit-outer-spin-button,
    ::v-deep input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
    text-align:center
    }

    /* Firefox */
    ::v-deep input[type=number] {
    -moz-appearance: textfield;
    -webkit-appearance: none;   /* Chrome, Safari, and Edge */
    appearance: none;           /* Standard property */
    text-align: center; 
    }

    ::v-deep .v-textarea textarea{
        line-height: 1rem;
    }
</style>